'use client';

import { Search } from 'lucide-react';
import { FC } from 'react';
import { useSearchCommand } from '@hooks/use-search-command';
import { useTranslations } from 'next-intl';

type SearchTriggerProps = {
  className?: string;
  renderLabel?: boolean;
};

const SearchTrigger: FC<SearchTriggerProps> = ({
  className,
  renderLabel = false
}) => {
  const { setOpen } = useSearchCommand();
  const t = useTranslations('common');

  return (
    <button
      type="button"
      title={t('search')}
      aria-label={t('search')}
      onClick={() => setOpen(true)}
      className={
        className ??
        'inline-flex min-h-11 min-w-11 items-center justify-center gap-2 rounded-md px-3 text-body-dense text-muted-foreground hover:bg-accent'
      }
    >
      <Search className="size-5" />
      {renderLabel && <span>{t('search')}…</span>}
    </button>
  );
};

export default SearchTrigger;
